/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import Grid from "@mui/material/Grid";
import StarIcon from "@mui/icons-material/Star";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { Box, Rating, Stack, Typography } from "@mui/material";
import ProductCard from "components/product-card/product-card";




function OrdersOverview({ top_selling_products = [] }) {
  return (
    <Box>
      <MDBox pt={3} px={3} pb={1}>
        <MDTypography variant="h6" fontWeight="medium">
          المنتجات الأكثر مبيعًا
        </MDTypography>
        <MDTypography variant="button" color="text" fontWeight="regular" sx={{ fontSize: 14 }}>
          قائمة بأكثر المنتجات مبيعًا لهذا الشهر
        </MDTypography>
      </MDBox>

      <Grid container spacing={2}>
        {top_selling_products && top_selling_products.length > 0 ? (
          top_selling_products.map((product) => (
            <Grid item size={{ xs: 12, md: 6, lg: 3 }} key={product.id}>
              <ProductCard product={product} />
            </Grid>
          ))
        ) : (
          <MDBox textAlign="center" width="100%" py={4}>
            <MDTypography variant="button" color="text">
              لا توجد بيانات منتجات أكثر مبيعًا
            </MDTypography>
          </MDBox>
        )}
      </Grid>

    </Box>

  );
}

export default OrdersOverview;
